import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { FEATURED, IMAGES } from "../../lib/data";
import { Reveal, Overline, LaunchBadge, Icon } from "../ui-kit";

const CARD_IMG = [IMAGES.tools, IMAGES.grinder, IMAGES.tools, IMAGES.tools];

export default function Featured() {
  const trackRef = useRef(null);

  const scrollBy = (dir) => {
    const el = trackRef.current;
    if (!el) return;
    el.scrollBy({ left: dir * (el.clientWidth * 0.8), behavior: "smooth" });
  };

  return (
    <section id="featured" className="relative py-24 md:py-32 bg-[#050505]" data-testid="featured-section">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Reveal className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <Overline index="01">Featured Line-up</Overline>
            <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight text-white">
              Engineered <span className="text-orange-500">Icons</span>
            </h2>
          </div>
          <div className="flex gap-3">
            <button onClick={() => scrollBy(-1)} data-testid="featured-prev" aria-label="Previous"
              className="h-12 w-12 border border-zinc-700 flex items-center justify-center text-white hover:border-orange-500 hover:text-orange-500 transition-colors">
              <ChevronLeft size={20} />
            </button>
            <button onClick={() => scrollBy(1)} data-testid="featured-next" aria-label="Next"
              className="h-12 w-12 border border-zinc-700 flex items-center justify-center text-white hover:border-orange-500 hover:text-orange-500 transition-colors">
              <ChevronRight size={20} />
            </button>
          </div>
        </Reveal>
      </div>

      <div
        ref={trackRef}
        className="flex gap-6 overflow-x-auto scrollbar-hide snap-x snap-mandatory px-5 md:px-8 pb-4"
        style={{ scrollbarWidth: "none" }}
        data-testid="featured-carousel"
      >
        {FEATURED.map((p, i) => (
          <Reveal
            key={i}
            delay={i * 0.08}
            className="snap-start shrink-0 w-[85%] sm:w-[420px]"
          >
            <div className="group relative h-[440px] bg-[#0a0a0a] border border-zinc-800 hover:border-orange-500/50 transition-colors overflow-hidden clip-notch"
              data-testid={`featured-card-${i}`}>
              <div className="absolute inset-0 overflow-hidden">
                <img src={CARD_IMG[i]} alt={p.name}
                  className="w-full h-full object-cover opacity-40 group-hover:opacity-60 group-hover:scale-105 transition-all duration-700" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/50 to-transparent" />
              </div>
              <div className="absolute top-5 left-5 z-10"><LaunchBadge /></div>
              <div className="absolute top-5 right-5 z-10 h-12 w-12 rounded-full bg-black/50 backdrop-blur border border-white/10 flex items-center justify-center text-orange-500">
                <Icon name={p.icon} size={22} />
              </div>
              <div className="absolute bottom-0 left-0 right-0 z-10 p-7">
                <span className="text-xs font-bold uppercase tracking-widest text-orange-500">{p.tag}</span>
                <h3 className="mt-2 font-display text-2xl font-bold uppercase text-white leading-tight">{p.name}</h3>
                <div className="mt-4 h-0.5 w-0 bg-orange-500 group-hover:w-16 transition-all duration-500" />
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
